import { render } from "./ViewPayrollRuns.vue?vue&type=template&id=388036c3"
import script from "./ViewPayrollRuns.vue?vue&type=script&lang=js"
export * from "./ViewPayrollRuns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__